module.exports = __webpack_public_path__ + "4614049cfb8a8a48904be1bf5569c60b.png";